"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var suplierCouponsApi = _interopRequireWildcard(require("@/api/suplierCouponsApi.js"));
var productSetting = _interopRequireWildcard(require("@/api/productSetting.js"));
var _validate = require("@/utils/validate");
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {},
  data: function data() {
    return {
      loading: false,
      visible: false,
      pram: {},
      details: {},
      // 预留一份数据
      supplierId: '',
      nameList: []
    };
  },
  mounted: function mounted() {
    this.pram = {};
  },
  methods: {
    openInit: function openInit(supplierId) {
      var _this = this;
      this.supplierId = supplierId;
      this.details = {};
      this.pram = {};
      this.nameList = [];
      productSetting.getComDetail(supplierId).then(function () {
        var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        _this.visible = true;
        _this.details = res;
        _this.pram = _objectSpread({}, res);
        if (res !== null && res !== void 0 && res.params) {
          var _Object$keys;
          (_Object$keys = Object.keys(res.params)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.forEach(function (paramsKey) {
            _this.nameList.push({
              key: paramsKey,
              value: res.params[paramsKey]
            });
          });
        }
        ;
      });
    },
    handerSubmit: (0, _validate.Debounce)(function (form) {
      var _this$nameList,
        _this2 = this;
      this.loading = true;
      var _ref = this.pram || {},
        corrAmount = _ref.corrAmount,
        priceType = _ref.priceType,
        id = _ref.id;
      var params = {};
      ((_this$nameList = this.nameList) === null || _this$nameList === void 0 ? void 0 : _this$nameList.length) && this.nameList.forEach(function (item) {
        params[item.key] = item.value;
        // let isPass = item.key&&(item.value||item.value==0);
        // if(isPass) {
        //   params[item.key]=item.value;
        // };
      });
      productSetting.UpdateArticle({
        corrAmount: corrAmount,
        priceType: priceType,
        id: id,
        params: params
      }).then(function (data) {
        _this2.$message.success('操作成功');
        _this2.loading = false;
        _this2.visible = false;
        _this2.$emit('doRefresh');
      }).catch(function () {
        _this2.loading = false;
      });
    }),
    closeEdit: function closeEdit() {
      this.visible = false;
    },
    removeNameItem: function removeNameItem(i) {
      this.nameList.splice(i, 1);
    }
  }
};